import { render, staticRenderFns } from "./discus-2.vue?vue&type=template&id=673f1d60&scoped=true&"
import script from "./discus-2.vue?vue&type=script&lang=js&"
export * from "./discus-2.vue?vue&type=script&lang=js&"
import style0 from "./discus-2.vue?vue&type=style&index=0&id=673f1d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f1d60",
  null
  
)

export default component.exports